import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
	selector: 're-sync-btn',
	template: require('./re-sync-btn.html'),
	styles: [require('./re-sync-btn.scss')]
})
export class ReSyncBtnComponent {
	@Input() isActive: boolean;
	@Input() lastSyncDate;
	@Output() syncEmails: EventEmitter<void> = new EventEmitter();

	constructor() {}

	public triggerEmailSync(): void {
		this.syncEmails.emit();
	}
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/string-replace-webpack-plugin/loader.js?id=os2z8rc99lf!./web/modern/components/buttons/re-sync-btn/re-sync-btn.ts